module.exports = __webpack_public_path__ + "static/media/Foto 6 Julián Coaguila - Foto Rufino Motta.489a9ef7.jpg";